import { ReportPayrollActions } from '../constants';
import { QueryParams } from 'src/types/grid';
import { ReportPayrollFormData } from 'src/screens/General/screens/Reports/components/ReportPayrollForm';
import { Dispatch } from 'redux';
import { SagaPromise } from './auth-actions';

export interface GetReportPayrollsAction {
    type: typeof ReportPayrollActions.FETCH_REPORT_PAYROLLS;
    payload: QueryParams;
    all?: any;
}

export function getReportPayrolls(params: QueryParams): GetReportPayrollsAction {
    return {
        type: ReportPayrollActions.FETCH_REPORT_PAYROLLS,
        payload: params,
    };
}
interface QueryParamsAll extends QueryParams {
    all?: any;
}
export function getPayrollsReportsCsv(params: QueryParamsAll): GetReportPayrollsAction {
    return {
        type: ReportPayrollActions.FETCH_PAYROLLS_REPORTS_CSV,
        payload: params,
        all: params.all,
    };
}
export interface PaidReportPayrollAction {
    type: typeof ReportPayrollActions.PAID_REPORT_PAYROLLS;
    payload: {
        data: { dateFrom: string; dateTo: string };
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function paidReportPayroll(
    data: { dateFrom: string; dateTo: string },
    onSuccess?: () => void,
    onError?: (error: string) => void,
): PaidReportPayrollAction {
    return {
        type: ReportPayrollActions.PAID_REPORT_PAYROLLS,
        payload: {
            data,
            onSuccess,
            onError,
        },
    };
}

export interface GetReportPayrollAction {
    type: typeof ReportPayrollActions.FETCH_REPORT_PAYROLL;
    payload: {
        id: string | number;
    };
}

export function getReportPayroll(id: string | number): GetReportPayrollAction {
    return {
        type: ReportPayrollActions.FETCH_REPORT_PAYROLL,
        payload: { id },
    };
}

export interface DeleteReportPayrollAction {
    type: typeof ReportPayrollActions.DELETE_REPORT_PAYROLL;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteReportPayroll(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteReportPayrollAction {
    return {
        type: ReportPayrollActions.DELETE_REPORT_PAYROLL,
        payload: { id, onSuccess, onError },
    };
}

export interface PersistReportPayrollAction {
    type: typeof ReportPayrollActions.PERSIST_REPORT_PAYROLL;
    payload: {
        data: ReportPayrollFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistReportPayroll(
    data: ReportPayrollFormData,
    callbacks: SagaPromise<any>,
): PersistReportPayrollAction {
    return {
        type: ReportPayrollActions.PERSIST_REPORT_PAYROLL,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistReportPayroll = (data: ReportPayrollFormData, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistReportPayroll(data, { resolve, reject }));
    });
};

export type Actions =
    | GetReportPayrollsAction
    | GetReportPayrollAction
    | DeleteReportPayrollAction
    | PaidReportPayrollAction
    | PersistReportPayrollAction;
